import { getQuizResultsTexts } from "./quiz-results-texts.js";

/**
 * Render refill toggle block state (Auto-Refill / One-Time) and support interaction binding.
 */

/**
 * @param {any} value
 * @returns {number}
 */
function asDiscountNumber(value) {
  const num = Number(value);
  return Number.isFinite(num) ? Math.abs(num) : 0;
}

/**
 * Generate the helper text under the toggle (parity with Angular refill-toggle template).
 *
 * @param {{ discount: any, isOtpOn: boolean }} state
 * @returns {string}
 */
function getToggleText(state) {
  const texts = getQuizResultsTexts();
  const discountValue = asDiscountNumber(state?.discount?.value);
  
  
  const isOtpOn = Boolean(state?.isOtpOn);

  if (discountValue > 0) {
    return isOtpOn
      ? `${discountValue}${texts.refillToggle.otpWithDiscount}`
      : `${discountValue}${texts.refillToggle.autoWithDiscount}`;
  }

  if (isOtpOn) {
    return texts.refillToggle.otpNoDiscount;
  }

  return "";
}

/**
 * @param {Element | null} rootElement
 * @param {{ discount: any, isOtpOn: boolean }} state
 */
export function renderRefillToggleBlock(rootElement, state) {
  if (!rootElement) return;

  const autoInput = /** @type {HTMLInputElement | null} */ (
    rootElement.querySelector('input[name="quiz-toggle"][value="auto"]')
  );
  const oneInput = /** @type {HTMLInputElement | null} */ (
    rootElement.querySelector('input[name="quiz-toggle"][value="one"]')
  );
  const textElement = rootElement.querySelector(".quiz-results-toggle-text");

  const isOtpOn = Boolean(state?.isOtpOn);

  if (autoInput) autoInput.checked = !isOtpOn;
  if (oneInput) oneInput.checked = isOtpOn;
  if (textElement) textElement.textContent = getToggleText(state);
}

/**
 * Attach change handler to radio controls and convert value to OTP boolean.
 * Returns cleanup function.
 *
 * @param {Element | null} rootElement
 * @param {(isOtpOn: boolean) => void} onToggle
 * @returns {() => void}
 */
export function bindRefillToggleBlock(rootElement, onToggle) {
  if (!rootElement || typeof onToggle !== "function") return () => {};

  const radioInputs = Array.from(
    rootElement.querySelectorAll('input[name="quiz-toggle"]'),
  );

  const handleChange = (/** @type {Event} */ event) => {
    const target = /** @type {HTMLInputElement | null} */ (event.target);
    if (!target) return;
    const isOtpOn = target.value === "one";
    onToggle(isOtpOn);
  };

  radioInputs.forEach((input) => input.addEventListener("change", handleChange));
  return () => {
    radioInputs.forEach((input) =>
      input.removeEventListener("change", handleChange),
    );
  };
}
